// extracted by mini-css-extract-plugin
export default {"wrapper":"landscapeOverlay__wrapper__z3gv0","phoneIcon":"landscapeOverlay__phoneIcon__gqdL_","phoneRotate":"landscapeOverlay__phoneRotate__HGxzC"};